import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  AuthCookieService,
  AuthService,
  BETALNINGSUPPGIFT_REMINDER_PENDING_KEY,
  BEDOMARE_REMINDER_PENDING_KEY,
} from '@vinnova/auth';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';

export const AuthGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> => {
  const authService = inject(AuthService);
  const authCookieService = inject(AuthCookieService);
  const router = inject(Router);

  if (
    !environment.b2cMsalConfig?.authority ||
    !environment.b2cMsalConfig?.scope
  ) {
    throw new Error('B2C auth or scopes is missing');
  }

  const cookie = authCookieService.getCookie();

  return authService.hasValidAccount().pipe(
    take(1),
    switchMap((hasValidAccount) => {
      if (
        cookie &&
        hasValidAccount &&
        authCookieService.isCurrentSiteLoggedIn()
      ) {
        return of(true);
      } else if (cookie) {
        return authService
          .login(state.url, environment.b2cMsalConfig.authority + cookie.tfp, [
            environment.b2cMsalConfig.scope,
          ])
          .pipe(
            take(1),
            map(() => false),
          );
      } else {
        sessionStorage.setItem(BETALNINGSUPPGIFT_REMINDER_PENDING_KEY, 'true');
        sessionStorage.setItem(BEDOMARE_REMINDER_PENDING_KEY, 'true');
        router.navigate(['/public/login'], {
          queryParams: { returnUrl: state.url === '/' ? undefined : state.url },
        });
      }

      return of(false);
    }),
  );
};

export const AuthGuardChild: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => AuthGuard(route, state);
